import type { UserDto } from 'enrollment-platform/pages/AccessControl/api/access-control.client'
import { useUsersLookupQuery } from 'enrollment-platform/pages/AccessControl/hooks/useUsersLookupQuery'
import { usePermission } from 'enrollment-platform/rbac/usePermission'

const NO_USERS: ReadonlyMap<string, UserDto> = new Map()

/**
 * The RBAC roles of a customer's admins, read in one batch lookup once the
 * viewer's ability allows Read on UserPermission. Without that permission,
 * until the lookup resolves, or when it fails, no admin has a row and the
 * rows show no roles.
 */
export default function useAdminRoles(adminIds: string[]): {
  userById: ReadonlyMap<string, UserDto>
} {
  const { allowed } = usePermission('Read', 'UserPermission')
  const { data } = useUsersLookupQuery(adminIds, allowed)
  return { userById: data ?? NO_USERS }
}
